import React from 'react';
import { Link, RouterLayoutProps, SideNavLayout, Stack } from 'shared';
import { GlobalFooter } from './GlobalFooter';
import { GlobalHeader } from './GlobalHeader';
import styles from './GlobalLayout.module.css';
import { TokenForceRefresher } from 'Auth';
import { useSentryUser } from 'Users/hooks/SentryUserProvider';
import { getCompanyLogo } from 'App/utils/logoUtils';
import { CompanyLogoImage } from 'App/components/CompanyLogoImage';

export const GlobalLayout: React.FC<RouterLayoutProps> = (props) => {
  const { user } = useSentryUser();

  const logoImage = getCompanyLogo(user || null);
  return (
    <div id={styles.globalLayout}>
      <TokenForceRefresher>
        <SideNavLayout
          {...props}
          siderProps={{
            topContent: (
              <Stack gap={16} direction="vertical">
                <div></div>
                <Link to="/">
                  <CompanyLogoImage
                    src={logoImage}
                    width="90%"
                    alt="Company Logo"
                    fallbackSrc="/sentry-logo.png"
                  />
                </Link>
                <div></div>
              </Stack>
            ),
            mode: 'inline',
          }}
          headerContent={<GlobalHeader />}
          footerContent={<GlobalFooter />}
        />
      </TokenForceRefresher>
    </div>
  );
};
